import React, { useState, useEffect, useRef, useCallback } from "react";
import { connect, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { setLoading, setSnackInfo } from "../redux/actions/appAction";
import { setUserDetails } from "../redux/actions/userAction";
import HttpService from "../services/httpService";
import moment from "moment";
import { commaSeparateAmount } from "../components/commaSeparate";
import { ROLENAME, salesDepartment, salesLostReasons } from "../utils/index";

import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  makeStyles,
  withStyles,
  TextField,
  Button,
  MenuItem,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  InputLabel,
  Select,
  FormControl,
  OutlinedInput
} from "@material-ui/core";

import Autocomplete from "@material-ui/lab/Autocomplete";

const useStyles = makeStyles((theme) => ({
  table: {
    minWidth: 700,
  },
  root: {
    width: "100%",
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
  tableViewButton: {
    backgroundColor: "#b7ccf7",
    color: "#151921",
    padding: "1",
    marginRight: "0.5em",
    borderRadius: "20px",
    width: "30%",
    "&:hover": { backgroundColor: "#14419c", color: "white" },
  },
  leadSearchButton: {
    backgroundColor: "#FDB913",
    color: "#151921",
    padding: "1",
    marginRight: "0.5em",
    borderRadius: "20px",
    width: "20%",
    "&:hover": { backgroundColor: "#14419c", color: "white" },
  },
}));

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#ccc",
    color: theme.palette.common.black,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const RaiseRefundRequest = (props) => {
  const classes = useStyles();
  const { userDetails } = useSelector((state) => state.user);
  const [qtprojects, setQTProjectRows] = useState([]);
  const [qtBoardViewProjects, setQTBoardViewProject] = useState([]);
  const [dupqtprojects, setDupQtProjects] = useState([]);
  const [searched, setSearched] = useState("");
  const [projectViewType, setProjectViewType] = useState();
  const [totalaPages, setTotalPages] = useState(0);
  const [assignToList, setAssignToList] = useState([]);
  const [usersData, setUsersData] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const [selectedSearchType, setSelectedSearchType] = useState([]);
  const [leadId, setLeadId] = useState("");
  const [sourceOfLeadData, setSourceOfLeadData] = useState([]);
  const [salesLostReasonOptions, setSalesLostReasonOptions] = useState(salesLostReasons);
  const [salesLostReason, setSalesLostReason] = useState("");
  const [refundRequestView, setRefundRequestView] = useState(false);
  const [refundAmount, setRefundAmount] = useState(0);
  const [totalAmountRefund, setTotalAmountrefund] = useState(0);
  const [refundReqDepartment, setRefundReqDepartment] = useState("");
  const [amountPaid, setAmountPaid] = useState(0);
  const [meetingDone, setMeetingDone] = useState("")
  const [meetingType, setMeetingType] = useState("")
  const [meetingDate, setMeetingDate] = useState(null);
  const [currentStage,setCurrentStage] = useState('')
  const [projectDetails, setProjectDetails] = useState({});
  const [chmRefundRequestDialog, setChmRefundRequestDialog] = useState(false);
  const [departmentStage, setDepartmentsStage] = useState([]);
  const [departmentList, setDepartmentList] = useState([]);
  const [raiseUser, setRaiseUser] = useState('')
  const [lostDialog, setLostDialog] = useState(false);
  const [lostRemark, setLostRemark] = useState('');
  const [salesToken, setSalesToken] = useState(0);
  const [paymentReceivedAmount, setPaymentReceivedAmount] = useState(0);
  const [paymentPercentValue, setPaymentPercentValue] = useState(0);
  const [unifiedLostDialog, setUnifiedLostDialog] = useState(false);
  const [wantsRefund, setWantsRefund] = useState(null); // null, 'yes', 'no'
  const [unifiedRefundAmount, setUnifiedRefundAmount] = useState(0);
  const [unifiedLostRemarks, setUnifiedLostRemarks] = useState('');
  const [unifiedDepartment, setUnifiedDepartment] = useState(''); // 'Design' or 'Sales'
  const [chmRefundItems, setChmRefundItems] = useState({
    delayPenality: 0,
    damages: 0,
    goodWillDiscount: 0,
    others: 0,
    referralBonus: 0,
  });

  const [searchTypes, setSearchTypes] = useState([
    { name: "Customer Name" },
    { name: "Email ID" },
    { name: "Lead No" },
    { name: "Project No" },
    { name: "Contact No" },
    { name: "Unique Lead No" },
  ]);

  useEffect(() => {
    getDepartments();
    getUserdata();
    getSourceOfLeadData();
  }, []);

  const getUserdata = async () => {
    const users = await HttpService.getAllMangers();
    setUsersData(users.data);
  };

  const getSourceOfLeadData = async () => {
    const users = await HttpService.getLeadMaster();
    setSourceOfLeadData(users.data);
    props.setSnackInfo("Please search lead to raise refund request","success")
  };

  const getSalesUser = (item) => {
    let salesDataObj = {
      sales_user: "",
      sales_teamId: "",
      sales_manager: "",
    };

    if (item?.assignTo?.roles.find((ele) => ele.name === ROLENAME.SalesUser)) {
      salesDataObj.sales_user = item?.assignTo?.name;
      salesDataObj.sales_teamId = item?.assignTo?.teamId;
    }
    for (let i = 0; i < item?.previouslyAssignedTo?.length; i++) {
      for (let j = 0; j < item?.previouslyAssignedTo[i]?.roles.length; j++) {
        if (
          item.salesLeadOwnRole === "SalesUser" &&
          item?.previouslyAssignedTo[i]?.roles[j].name === ROLENAME.SalesUser
        ) {
          salesDataObj.sales_user = item?.previouslyAssignedTo[i]?.name;
          salesDataObj.sales_teamId = item?.previouslyAssignedTo[i]?.teamId;
        } else if (
          item.salesLeadOwnRole === "SalesManager" &&
          item?.previouslyAssignedTo[i]?.roles[j].name === ROLENAME.SalesManager
        ) {
          salesDataObj.sales_manager = item?.previouslyAssignedTo[i]?.name;
          salesDataObj.sales_user = "NA";
        }
      }
    }

    if (
      item?.assignTo?.roles.find((ele) => ele.name === ROLENAME.SalesManager)
    ) {
      salesDataObj.sales_manager = item?.assignTo?.name;
    }
    return salesDataObj;
  };

  const setHandleSearchedByEnter = (e) => {
    if (e.keyCode === 13) {
      setSearched(searchInput);
      requestSearch(selectedSearchType, searchInput);
    }
  };
  const setHandleSearched = (value) => {
    setSearched(value);
    requestSearch(selectedSearchType, value);
  };

  const requestSearch = async (searchType, search) => {
    try {
      let data = {};
      data.role = "others";
      props.setLoading(true);
      const response = await HttpService.getRefundRequestSearchLeads(
        searchType.name,
        search,
        userDetails.selectedExpCenter,
      );
      props.setLoading(false);
      if (response.data && response.data.totalDocs >= 0) {
          if(response.data.totalDocs === 0){
            let snackString = String(response.data.totalDocs) + " Leads Found!";
            props.setSnackInfo(snackString, "success");
          }
      }
      let i = 1;
      let userTableViewData = [];
      const assignUserList = [];
      response?.data?.docs?.forEach((ele) => {
        ele["projects"]?.forEach((item) => {
          let data = getSalesUser(item);
          item.serial = i++;
          let obj = {
            projectId: item?._id,
            name: item?.customerId?.name,
            lead_no: item?.lead_no,
            customerId: item?.customerId?._id,
            status: item?.status,
            erpProjectNo: item?.erpProjectNo ? item?.erpProjectNo : "-",
            currentStage: item?.currentStage,
            stage: item?.salesStage === "Won" ? item.designStages : item?.salesStage,
            assignTo: item?.assignTo?.name,
            departmentId: item?.departmentId._id,
            department: item?.departmentId?.name,
            totalCustomerOutflow: item?.grandTotal ? item?.grandTotal : `0`,
            reasonForLost:item?.currentStage === "Lost" ? item?.reasonForLost : "-",
            createdAt: moment(item?.createdAt).format("DD-MM-YYYY"),
            lastActivityDate: moment(item?.lastActivityDate).format( "DD-MM-YYYY"),
            uniqueLeadNumber: item?.uniqueLeadNumber,
            expectedSalesclosureDate: item?.expectedSalesclosureDate? moment(item?.expectedSalesclosureDate).format("DD-MM-YYYY"): "NA",
            salesUser: data.sales_user !== "" ? data.sales_user : "NA",
            salesUserTeamId: data.sales_teamId,
            salesManagerName: data.sales_manager,
            expectedHandoverDate: moment(item?.expectedHandoverDate).format( "DD-MM-YYYY"),
            salesStage: item?.salesStage ? item?.salesStage : "-",
            designStages: item?.designStages ? item?.designStages : "-",
            designKickOffCustomerActionFromChm:item?.designKickOffCustomerActionFromChm,
            isRefundRequestSent: item?.isRefundRequestSent ? item?.isRefundRequestSent : "-",
            designLostApproval: item?.designLostApproval,
            salesLostApproval: item?.salesLostApproval,
            salesRefundRequestApproval: item?.salesRefundRequestApproval,
            designRefundRequestApproval: item?.designRefundRequestApproval,
            contractCustomerApproved: item?.contractCustomerApproved,
            contractFinanceApproved: item?.contractFinanceApproved,
            salesToken: item?.salesToken || 0,
            raiseRefundLostSent: item?.raiseRefundLostSent,
            raiseRefundLostUser: item?.raiseRefundLostUser,
            totalAmountRefundedArray: item?.totalAmountRefundedArray
          };
          userTableViewData.push(obj);
          assignUserList.push(item.assignTo?.name);
        });
      });

      const uniqueAssignToList = Array.from(
        new Set(assignUserList.map((a) => a))
      ).map((id) => {
        return assignUserList.find((a) => a === id);
      });
      setAssignToList(uniqueAssignToList);
      setQTProjectRows(userTableViewData);
      setProjectDetails(userTableViewData[0]);
      setDupQtProjects(userTableViewData);
      setQTBoardViewProject(response.data.docs);
      setTotalPages(response.data.totalDocs);
    } catch (error) {
      console.log(error);
    }
  };


  const getDepartments = async () => {
    try {
      const department = await HttpService.getDepartments();
      setDepartmentList(department?.data);
      getDepartmentStages(department?.data);
    } catch (error) {
      console.log(error, "get department error");
    }
  };

  const getDepartmentStages = async (data) => {
    let stages = [];
    if (
      userDetails.roles.find(
        (role) =>
          role.name === ROLENAME.MarketingUser ||
          role.name === ROLENAME.MarketingManager
      )
    ) {
      data.forEach((element) => {
        if (element["name"] === "Sales") {
          stages.push(element["stages"]);
        }
      });
    } else if (
      userDetails.roles.find(
        (role) =>
          role.name === ROLENAME.Admin ||
          role.name === ROLENAME.ProcurementExecutive
      )
    ) {
      return;
    } else {
      data.forEach((element) => {
        if (element["_id"] === userDetails.departmentId) {
          stages.push(element["stages"]);
        }
      });
    }
    setDepartmentsStage(stages?.[0] ? stages?.[0] : "");
  };

  const handle_search_type_selection = (value) => {
    setSelectedSearchType(value);
    setSearchInput("");
  };

  // handle handleRefundRequestButton when click refund request button
  const handleRefundRequestButton = async (stage, row) => {
    props.setLoading(true);
    try {
      if (stage !== "CHM") {
        const designApproval = row?.designLostApproval;
        const salesApproval = row?.salesLostApproval;
        // if lead lost is pending approval
        if (
          designApproval?.odmApproval === "Sent for Approval" ||
          designApproval?.dgmDesignApproval === "Sent for Approval" ||
          designApproval?.adminApproval === "Sent for Approval" ||
          salesApproval?.smApproval === "Sent for Approval" ||
          salesApproval?.dgmSalesApproval === "Sent for Approval" ||
          salesApproval?.centerHeadApproval === "Sent for Approval"
        ) {
          props.setSnackInfo("Please wait until the lost approval done", "warning");
        } else {
          if(row?.salesStage === 'Lost' || row?.designStages === 'Lost'){
          const res = await HttpService.getAmountPaid(row.projectId);
          setAmountPaid(res?.data?.totalPaymentReceived);
          setRefundRequestView(true);
          setLeadId(row.projectId);
          setRefundReqDepartment(stage);
          setRaiseUser(userDetails._id);
          let sumOfRefundedAmount = row?.totalAmountRefundedArray?.reduce((sum,item)=>{
            return sum+ item?.amountRefunded
          },0)
          // setTotalAmountrefund(res.data.totalPaymentReceived);
          setTotalAmountrefund(Number(res.data.totalPaymentReceived) - (Number(sumOfRefundedAmount) || 0));
          } else{
            props.setSnackInfo("Please move lead to lost for raise refund request", "warning");
          }
        }
      } //If stage is chm then come into else part of parent if
      else {
          setRaiseUser(userDetails._id);
          setChmRefundRequestDialog(true);
          setLeadId(row.projectId);
          setRefundReqDepartment(stage);
      }
    } catch (err) {
      props.setSnackInfo("Something went wrong", "error");
    }
    props.setLoading(false);
  };

  // handleEnterRefundAmount function (Enter value for refund and total refund amount calculate)
  const handleEnterRefundAmount = (value) => {
    setRefundAmount(+value);
    let sumOfRefundedAmount = projectDetails?.totalAmountRefundedArray?.reduce((sum,item)=>{
      return sum + item.amountRefunded;
    },0)
    let totalAmount = amountPaid - (Number(value) + (Number(sumOfRefundedAmount) || 0));
    setTotalAmountrefund(totalAmount);
  };

  // handle refund request submit button
  const handleRefundSubmit = async () => {
    props.setLoading(true);
    try {
      if (refundAmount > 0) {
        const obj = {
          amountPaid: amountPaid,
          refundAmount: refundAmount, //Enter refund amount by raising request user
          totalAmountRefund: totalAmountRefund,
          refundReqDepartment: refundReqDepartment,
          refundRaiseUser : raiseUser
        };
        await HttpService.sendApprovalRefundRequest(leadId, obj);
        setRefundRequestView(false);
        setHandleSearched(searchInput.toUpperCase());
        if (
          projectDetails.salesStage !== "Lost" &&
          projectDetails.designStages !== "Lost"
        ) {
          props.setSnackInfo(
            "Refund request sent for approval and lead will be lost once it's approved ",
            "success"
          );
        } else {
          props.setSnackInfo("Refund request sent for approval", "success");
        }
      } else {
        props.setSnackInfo("Please enter refund amount", "warning");
      }
    } catch (err) {
      console.log(err);
      props.setSnackInfo("Something went wrong", "error");
    }
    props.setLoading(false);
  };

  // handle Cancel button when raising refund request
  const handleCancelButton = () => {
    setRefundRequestView(false);
    setRefundAmount(0);
  };

  //   handle handleChmRefundRequest CHM Refund Request approval
  const handleChmRefundRequest = (e) => {
    setChmRefundItems((prev) => ({
      ...prev,
      [e.target.name]: +e.target.value,
    }));
  };

  // handle CHM cancel button for Raise Refund Request
  const handleChmCancelButton = () => {
    setChmRefundRequestDialog(false);
    setChmRefundItems({
      delayPenality: 0,
      damages: 0,
      goodWillDiscount: 0,
      others: 0,
      referralBonus: 0,
    });
  };

  // handle CHM Submit button for Raise Refund Request
  const handleChmRefundSubmit = async () => {
    props.setLoading(true);
    try {
      const sum = Object?.entries(chmRefundItems)?.reduce((acc, [key, value]) => {
        return acc + value;
      }, 0);

      const obj = {
        refundItems: chmRefundItems,
        refundReqDepartment: refundReqDepartment,
        refundRaiseUser : raiseUser,
        refundAmount: sum,
      };
      const res = await HttpService.sendChmRefundApproval(obj, leadId);
      setChmRefundRequestDialog(false);
      setHandleSearched(searchInput.toUpperCase())
      props.setSnackInfo("Refund request sent for approval", "success");
    } catch (err) {
      console.log("error", err);
      props.setSnackInfo("Something went wrong", "error");
    }
    props.setLoading(false);
  };

  const handleUnifiedLostSubmit = async() => {
    props.setLoading(true);
    try {
      const paymentEligible = Number(paymentReceivedAmount) > 0 || Number(salesToken) >= 10;
      const needsRefund = paymentEligible && wantsRefund === 'yes';
      let obj = {
        needsRefund,
        refundAmount: needsRefund ? parseFloat(unifiedRefundAmount) : 0,
            reasonForLost: salesLostReason,
            remarks: unifiedLostRemarks,
            department: unifiedDepartment,
            salesToken: salesToken
        };

        // Add meeting details for Sales department
        if (unifiedDepartment === 'Sales') {
            if (meetingDone === "Yes") {
                obj.meetingDetails = {
                    meetingType: meetingType,
                    meetingDate: meetingDate,
                    meetingStage: currentStage,
                    meetingNotDone: false
                };
            } else if (meetingDone === "No") {
                obj.meetingDetails = {
                    meetingNotDone: true,
                    meetingDate: new Date()
                };
            }
        }

        await HttpService.moveLeadToLostUnified(leadId, obj);
        setUnifiedLostDialog(false);
        
        // Reset all states
        setWantsRefund(null);
        setUnifiedRefundAmount(0);
        setUnifiedLostRemarks('');
        setSalesLostReason('');
        setMeetingDone('');
        setMeetingType('');
        setMeetingDate(null);
        setPaymentReceivedAmount(0);
        
        setHandleSearched(searchInput.toUpperCase());
        props.setSnackInfo(
          needsRefund 
            ? "Lead moved to Lost with refund request sent for approval" 
            : "Lead moved to Lost sent for approval",
          'success'
        );
    }
    catch (err) {
      console.error('Error in unified lost submit:', err);
      props.setSnackInfo(err?.response?.data?.error || 'Something went wrong',"error");
    }
    props.setLoading(false);
  }

  const handleUnifiedLostCancel = () => {
    setUnifiedLostDialog(false);
    setWantsRefund(null);
    setUnifiedRefundAmount(0);
    setUnifiedLostRemarks('');
    setSalesLostReason('');
    setMeetingDone('');
    setMeetingType('');
    setMeetingDate(null);
    setPaymentReceivedAmount(0);
    setPaymentPercentValue(0);
    setPaymentPercentValue(0);
  }

  const handleMoveToLost = async (depatment, row)=>{
    props.setLoading(true);
    // Use unified Lost+Refund dialog
    setUnifiedLostDialog(true);
    setLeadId(row?.projectId);
    const token = Number(row?.salesToken || row?.tokenPercent || 0);
    setSalesToken(token);
    setPaymentPercentValue(Number(row?.paymentPercent || 0));
    setUnifiedDepartment(depatment);
    setCurrentStage(row?.currentStage);
    setRefundReqDepartment(depatment);

    // Fetch actual payments to decide refund eligibility
    let paid = 0;
    try {
      const res = await HttpService.getAmountPaid(row?.projectId);
      paid = Number(res?.data?.totalPaymentReceived || 0);
    } catch (err) {
      paid = 0;
    }
    setPaymentReceivedAmount(paid);

    // Reset unified dialog states
    const paymentEligible = paid > 0 || token >= 10 || Number(row?.paymentPercent || 0) >= 10;
    setWantsRefund(paymentEligible ? null : 'no');
    setUnifiedRefundAmount(0);
    setUnifiedLostRemarks('');
    setSalesLostReason('');
    setMeetingDone('');
    setMeetingType('');
    setMeetingDate(null);
    props.setLoading(false);
  }

  const handleLost = async () => {
    try {
      let obj = {
        remark: lostRemark,
        reasonForSalesLost: salesLostReason,
        status: "Lost",
        salesToken: salesToken,
        raiseRefundLostUser: userDetails._id
      }
      let res = await HttpService.moveRefundLeadLost(obj, leadId);
      setLostDialog(false);
      setLostRemark('');
      setSalesLostReason("")
      setHandleSearched(searchInput.toUpperCase());
      props.setSnackInfo("Sent for Lost Approval", 'success');
    }
    catch (err) {
      props.setSnackInfo('Something went wrong', "error")
    }
  }

  const handleLostCancel = ()=>{
    setLostDialog(false);
    setLostRemark('');
    setSalesLostReason('');
  }

  const handleSelectSalesLostReason = (event) => {
    setSalesLostReason(event.target.value);
  };

  const refundEligible = (Number(paymentReceivedAmount) > 0) || Number(salesToken) >= 10 || Number(paymentPercentValue) >= 10;

  return (
    <div>
      <Paper
        style={{ marginTop: "20px", marginBottom: "20px", padding: "20px" }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            margin: "Auto",
          }}
        >
          {/* Search Type */}
          <TextField
            select 
            // disabled={true}
            disabled={!userDetails?.roles?.find(role => role.name === ROLENAME.CHM_Manager || role.name === ROLENAME.CHM_User)}
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={selectedSearchType}
            label="Search Type"
            name="searchType"
            onChange={(e) => handle_search_type_selection(e.target.value)}
            variant="outlined"
            style={{ width: "30%", marginRight: "2%" }}
            size="small"
          >
            {searchTypes.map((el) => (
              <MenuItem key={el.name} value={el}>
                {el.name}
              </MenuItem>
            ))}
          </TextField>

          {/* Search Input */}
          <TextField
            label="Enter the input"
            name="searched"
            size="small"
            // disabled={true}
            disabled={!userDetails?.roles?.find(role => role.name === ROLENAME.CHM_Manager || role.name === ROLENAME.CHM_User)}
            value={searchInput}
            onKeyDown={setHandleSearchedByEnter}
            onChange={(e) => {
              setSearchInput(e.target.value);
            }}
            variant="outlined"
            style={{ width: "80%" }}
          />

          {/* Search Button */}
          {userDetails?.roles?.find(
            (role) =>
              role.name !== "Procurement Executive" &&
              role.name !== "Store Manager"
          ) && (
            <Button
              // disabled={!selectedSearchType.name || !searchInput}
              // disabled={true}
              disabled={
                !userDetails?.roles?.find(role => role.name === ROLENAME.CHM_Manager || role.name === ROLENAME.CHM_User) ||
                !selectedSearchType.name || 
                !searchInput
              }
              variant="contained"
              color="primary"
              size="medium"
              style={{ alignSelf: "center", marginLeft: 20 }} // Added height
              className={classes.leadSearchButton}
              onClick={() => setHandleSearched(searchInput.toUpperCase())}
            >
              Search
            </Button>
          )}
        </div>
      </Paper>
      {!(userDetails?.roles?.some(role => role.name === ROLENAME.CHM_Manager || role.name === ROLENAME.CHM_User)) && (
          <div style={{ color: "red", textAlign: "center", marginTop: "10px", fontWeight: "bold" }}>
            This page is no longer functional. To request a refund, please navigate to the specific Lead and move it to 'Lost'.
          </div>
        )}
      <Paper>
        <TableContainer component={Paper}>
          <Table
            className={classes.table}
            stickyHeader
            aria-label="sticky table"
          >
        {qtprojects.length > 0 && 
           <TableHead>
              <StyledTableRow>
                <StyledTableCell>Sr. No.</StyledTableCell>
                <StyledTableCell>Customer</StyledTableCell>
                <StyledTableCell>Lead No</StyledTableCell>
                <StyledTableCell>Unique Lead No</StyledTableCell>
                <StyledTableCell>Project No.</StyledTableCell>
                <StyledTableCell>Department</StyledTableCell>
                <StyledTableCell>Status</StyledTableCell>
                <StyledTableCell>Current Stage</StyledTableCell>
                <StyledTableCell>Assigned to</StyledTableCell>
                <StyledTableCell>Quotation Amount</StyledTableCell>
                <StyledTableCell>Action</StyledTableCell>
              </StyledTableRow>
            </TableHead>
          }
            <TableBody>
              {qtprojects
                .sort((a, b) =>
                  b.createdAt
                    .split("-")
                    .reverse()
                    .join()
                    .localeCompare(a.createdAt.split("-").reverse().join())
                )
                .map((row, i) => {
                  return (
                    <StyledTableRow key={i + 1}>
                      <StyledTableCell>{i + 1}</StyledTableCell>
                      <StyledTableCell component="th" scope="row">
                        <Link
                          to={`/project-logs/${row.projectId}`}
                          style={{ color: "#000", textDecoration: "underline" }}
                        >
                          {row?.name}
                        </Link>
                      </StyledTableCell>
                      <StyledTableCell component="th" scope="row">{row?.lead_no}</StyledTableCell>
                      <StyledTableCell component="th" scope="row">{row?.uniqueLeadNumber ? row?.uniqueLeadNumber: "NA"}</StyledTableCell>
                      <StyledTableCell component="th" scope="row">{row?.erpProjectNo}</StyledTableCell>
                      <StyledTableCell component="th" scope="row"> {row?.department}</StyledTableCell>
                      <StyledTableCell component="th" scope="row">{row?.status}</StyledTableCell>
                      <StyledTableCell component="th" scope="row">{row?.currentStage}</StyledTableCell>
                      <StyledTableCell component="th" scope="row">{row?.assignTo}</StyledTableCell>
                      <StyledTableCell component="th" scope="row">₹ {commaSeparateAmount(row?.totalCustomerOutflow)}</StyledTableCell>
                      <StyledTableCell>
                        {userDetails.roles.some(
                          (role) =>
                            [ROLENAME.AssistantSalesManager, ROLENAME.SalesUser, ROLENAME.OperationDesignManager, ROLENAME.DesignUser].includes(role.name)
                        ) ? (
                          row?.salesStage === "Won" ? (
                            (row?.designStages === "Design Kick-Off : Internal" ||
                              row?.designStages === "Designer Assignment Pending" ||
                              row?.designStages === "Design Kick-Off : Customer") &&
                              (row?.designKickOffCustomerActionFromChm !== "Approved" && userDetails?.departmentId !== row?.departmentId)
                            ? (
                              <>
                              <Button
                                variant="contained"
                                color="primary"
                                style={{ marginTop: 10, float: "right" }}
                                onClick={() => handleRefundRequestButton("Sales", row)}
                                disabled={
                                  row?.isRefundRequestSent === true ||
                                  userDetails?.departmentId === row?.departmentId?._id
                                }
                              >
                                 Raise Refund Request
                              </Button>
                               <Button
                               variant="contained"
                               color="secondary"
                               style={{ marginTop: 10, float: "right" }}
                               onClick={() => handleMoveToLost("Sales", row)}
                               disabled={row?.salesStage === 'Lost' || row?.raiseRefundLostSent}
                           >
                             Move Lead To Lost                           
                           </Button>
                          </>
                            ) : userDetails.roles.some(
                              (role) =>
                                [ROLENAME.OperationDesignManager, ROLENAME.DesignUser].includes(role.name)
                            ) &&  row?.designKickOffCustomerActionFromChm === "Approved" ? (
                              <>
                              <Button
                                variant="contained"
                                color="primary"
                                style={{ marginTop: 10, float: "right" }}
                                onClick={() => handleRefundRequestButton("Design", row)}
                                disabled={row?.isRefundRequestSent === true}
                              >
                                Raise Refund Request
                              </Button>
                               <Button
                               variant="contained"
                               color="secondary"
                               style={{ marginTop: 10, float: "right" }}
                               onClick={() => handleMoveToLost("Sales", row)}
                                disabled={row?.designStages === 'Lost' || row?.raiseRefundLostSent}
                              >
                               Move Lead To Lost                             
                             </Button>
                          </>
                            ) : (
                              "NA"
                            )
                          ) : row?.salesStage === "Won Deals Pending Designer Assignment" &&
                            (row?.designKickOffCustomerActionFromChm === "Rejected" ||  row?.designKickOffCustomerActionFromChm === "Pending") ? (
                              <>
                            <Button
                              variant="contained"
                              color="primary"
                              style={{ marginTop: 10, float: "right" }}
                              onClick={() => handleRefundRequestButton("Sales", row)}
                              disabled={row?.isRefundRequestSent === true}
                            >
                               Raise Refund Request
                            </Button>
                            <Button
                             variant="contained"
                             color="secondary"
                             style={{ marginTop: 10, float: "right" }}
                             onClick={() => handleMoveToLost("Sales", row)}
                             disabled={row?.salesStage === 'Lost' || row?.raiseRefundLostSent}
                           >
                            Move Lead To Lost                              
                           </Button>
                           </>

                          ) : row?.salesStage === "Lost" && ( row?.raiseRefundLostUser && row?.raiseRefundLostSent)? (
                              <>
                              <Button
                                variant="contained"
                                color="primary"
                                style={{ marginTop: 10, float: "right" }}
                                onClick={() => handleRefundRequestButton("Sales", row)}
                                disabled={row?.isRefundRequestSent === true}
                              >
                                Raise Refund Request
                              </Button>
                              <Button
                                variant="contained"
                                color="secondary"
                                style={{ marginTop: 10, float: "right" }}
                                onClick={() => handleMoveToLost("Sales", row)}
                                 disabled={row?.isRefundRequestSent === true || row?.raiseRefundLostSent === true}
                            >
                             Move Lead To Lost                             
                            </Button>
                           </>
                          ) : (
                            "NA"
                          )
                        ) : userDetails.roles.some((role) => role.name === ROLENAME.CHM_User) &&
                          row?.contractCustomerApproved &&
                          row?.contractFinanceApproved &&
                          row?.designStages === "Design Sign-off" ? (
                            <>
                          <Button
                            variant="contained"
                            color="primary"
                            style={{ marginTop: 10, float: "right" }}
                            onClick={() => handleRefundRequestButton("CHM", row)}
                            disabled={row?.isRefundRequestSent === true}
                          >
                            Raise Refund Request
                          </Button>
                      </>
                        ) : (
                          "NA"
                        )}
                      </StyledTableCell>
                    </StyledTableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>

      {/* Refund Request Modal */}
      <Dialog
        open={refundRequestView}
        onClose={() => setRefundRequestView(false)}
      >
        <DialogTitle style={{ margin: "auto" }}> Refund Request </DialogTitle>
        <DialogActions>
          <TableContainer style={{ marginTop: 10 }}>
            <Table size="small">
              <TableBody>
                <TableRow>
                  <TableCell>Amount paid</TableCell>
                  <TableCell>
                    <TextField
                      name="amountPaid"
                      size="small"
                      value={amountPaid}
                      disabled
                      type="number"
                      fullWidth
                      label="Amount received"
                      variant="outlined"
                    />
                  </TableCell>
                </TableRow>
               {projectDetails?.totalAmountRefundedArray?.map((item,idx)=>
                <TableRow key={idx}>
                  <TableCell>Amount Refunded</TableCell>
                    <TableCell>
                      <TextField
                        disabled
                        name="totalAmountRefunded"
                        size="small"
                        value={item.amountRefunded}
                        type="number"
                        fullWidth
                        variant="outlined"
                      />
                    </TableCell>
                  </TableRow>
               )}
                <TableRow>
                  <TableCell>Amount to be refunded</TableCell>
                  <TableCell>
                    <TextField
                      name="amountToBeRefund"
                      size="small"
                      value={refundAmount}
                      onChange={(e) => handleEnterRefundAmount(e.target.value)}
                      type="number"
                      label="Amount to be refunded"
                      fullWidth
                      variant="outlined"
                    />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Balance Amount</TableCell>
                  <TableCell>
                    <TextField
                      name="totalAmountRefund"
                      size="small"
                      value={totalAmountRefund}
                      type="number"
                      label="Balance Amount"
                      fullWidth
                      variant="outlined"
                    />
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
            <div style={{ margin: "10px", float: "right" }}>
              <Button
                onClick={handleRefundSubmit}
                style={{ marginRight: "3px" }}
                color="primary"
                variant="contained"
              >
                Submit
              </Button>
              <Button
                onClick={handleCancelButton}
                color="secondary"
                variant="contained"
              >
                Cancel
              </Button>
            </div>
          </TableContainer>
        </DialogActions>
      </Dialog>

      {/* CHM_User refund request modal */}
      <Dialog
        open={chmRefundRequestDialog}
        onClose={() => setChmRefundRequestDialog(false)}
      >
        <DialogTitle style={{ margin: "auto" }}> CHM User Refund Request </DialogTitle>
        <DialogActions>
          <TableContainer style={{ marginTop: 10 }}>
            <Table size="small">
              <TableBody>
              {projectDetails?.totalAmountRefundedArray?.map((item,idx)=>
                <TableRow key={idx}>
                  <TableCell>Amount Refunded</TableCell>
                    <TableCell>
                      <TextField
                        name="totalAmountRefunded"
                        size="small"
                        value={item.amountRefunded}
                        type="number"
                        fullWidth
                        disabled
                        variant="outlined"
                      />
                    </TableCell>
                  </TableRow>
               )}
                <TableRow>
                  <TableCell>Delay Penality</TableCell>
                  <TableCell>
                    <TextField
                      name="delayPenality"
                      size="small"
                      value={chmRefundItems.delayPenality}
                      onChange={(e) => handleChmRefundRequest(e)}
                      type="number"
                      label="Delay Penality"
                      fullWidth
                      variant="outlined"
                    />
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell>Damages</TableCell>
                  <TableCell>
                    <TextField
                      name="damages"
                      size="small"
                      value={chmRefundItems.damages}
                      onChange={(e) => handleChmRefundRequest(e)}
                      type="number"
                      label="Damages"
                      fullWidth
                      variant="outlined"
                    />
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell>Good Will Discount</TableCell>
                  <TableCell>
                    <TextField
                      name="goodWillDiscount"
                      size="small"
                      value={chmRefundItems.goodWillDiscount}
                      onChange={(e) => handleChmRefundRequest(e)}
                      type="number"
                      label="Good Will Discount"
                      fullWidth
                      variant="outlined"
                    />
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell>Others</TableCell>
                  <TableCell>
                    <TextField
                      name="others"
                      size="small"
                      value={chmRefundItems.others}
                      onChange={(e) => handleChmRefundRequest(e)}
                      type="number"
                      label="Others"
                      fullWidth
                      variant="outlined"
                    />
                  </TableCell>
                </TableRow>

                {/* <TableRow>
                  <TableCell>Referral Bonus</TableCell>
                  <TableCell>
                    <TextField
                      name="referralBonus"
                      size="small"
                      value={chmRefundItems.referralBonus}
                      onChange={(e) => handleChmRefundRequest(e)}
                      type="number"
                      label="Referral Bonus"
                      fullWidth
                      variant="outlined"
                    />
                  </TableCell>
                </TableRow> */}
              </TableBody>
            </Table>
            <div style={{ margin: "10px", float: "right" }}>
              <Button
                onClick={handleChmCancelButton}
                color="secondary"
                variant="contained"
              >
                Cancel
              </Button>
                <Button
                onClick={handleChmRefundSubmit}
                style={{ marginRight: "3px" }}
                color="primary"
                variant="contained"
              >
                Submit
              </Button>
            </div>
          </TableContainer>
        </DialogActions>
      </Dialog>

      {/* Move to lost lead in refund request */}
      <Dialog
        open={lostDialog}
        onClose={() => setLostDialog(false)}
      >
        <DialogTitle style={{ margin: "auto" }}> Confirm moving the lead to lost </DialogTitle>
        <DialogContent>
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <FormControl
              fullWidth
              style={{ marginTop: "15px" }}
              variant="outlined"
              size="small"
            >
              <InputLabel htmlFor="outlined-adornment-amount">
                Reason for Lost *
              </InputLabel>
              <Select
                labelId="select-reason-label"
                id="select-reason"
                value={salesLostReason}
                label="Reason for Lost"
                onChange={handleSelectSalesLostReason}
                size="small"
                style={{ fontSize: "0.85rem", marginLeft: 10, marginRight: 30 }}
              >
                {salesLostReasonOptions.map((row, i) => (
                  <MenuItem key={i + 1} value={row.name} style={{ fontSize: "0.85rem" }}>
                    {row.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
        </DialogContent>
        <DialogActions>
            <div style={{ margin: "10px", display:'flex' }}>
              <Button
                onClick={handleLost}
                style={{ marginRight: "3px" }}
                color="primary"
                variant="contained"
                disabled = {salesLostReason === ''}
              >
                Submit
              </Button>
              <Button
                onClick={handleLostCancel}
                color="secondary"
                variant="contained"
              >
                Cancel
              </Button>
            </div>
        </DialogActions>
      </Dialog>
      <Dialog 
        open={unifiedLostDialog} 
        onClose={handleUnifiedLostCancel}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle style={{ backgroundColor: '#f5f5f5', fontWeight: 'bold' }}>
          Move Lead to Lost
        </DialogTitle>
        <DialogContent style={{ paddingTop: 20 }}>
          <div>
            {/* Refund Request Popup - YES/NO Choice - Only shown if payment received */}
            {refundEligible && (
              <Box
                style={{
                  backgroundColor: '#fff3cd',
                  border: '1px solid #ffc107',
                  borderRadius: 8,
                  padding: 16,
                  marginBottom: 20
                }}
              >
                <p style={{ margin: 0, marginBottom: 12, fontSize: '1rem', fontWeight: 'bold', color: '#856404' }}>
                  Do you want to raise a refund request?
                </p>
                <div style={{ display: 'flex', gap: 10 }}>
                  <Button
                    variant={wantsRefund === 'yes' ? "contained" : "outlined"}
                    color="primary"
                    onClick={() => setWantsRefund('yes')}
                    style={{
                      flex: 1,
                      backgroundColor: wantsRefund === 'yes' ? '#28a745' : 'transparent',
                      borderColor: '#28a745',
                      color: wantsRefund === 'yes' ? 'white' : '#28a745'
                    }}
                  >
                    YES
                  </Button>
                  <Button
                    variant={wantsRefund === 'no' ? "contained" : "outlined"}
                    color="secondary"
                    onClick={() => setWantsRefund('no')}
                    style={{
                      flex: 1,
                      backgroundColor: wantsRefund === 'no' ? '#dc3545' : 'transparent',
                      borderColor: '#dc3545',
                      color: wantsRefund === 'no' ? 'white' : '#dc3545'
                    }}
                  >
                    NO
                  </Button>
                </div>
              </Box>
            )}

            {/* Refund Amount - Show only if YES */}
            {wantsRefund === 'yes' && (
              <FormControl fullWidth style={{ marginBottom: 15 }} variant="outlined" size="small">
                <TextField
                  label="Refund Amount *"
                  name="unifiedRefundAmount"
                  type="number"
                  value={unifiedRefundAmount}
                  onChange={(e) => setUnifiedRefundAmount(e.target.value)}
                  variant="outlined"
                  size="small"
                  required
                  inputProps={{ min: 0, step: 0.01 }}
                />
              </FormControl>
            )}

            {/* Sales Department - Meeting Details */}
            {unifiedDepartment === 'Sales' && (
              <>
                <FormControl fullWidth style={{ marginBottom: 15 }} variant="outlined" size="small">
                  <InputLabel>Meeting Done? *</InputLabel>
                  <Select
                    value={meetingDone}
                    onChange={(e) => setMeetingDone(e.target.value)}
                    label="Meeting Done? *"
                    size="small"
                  >
                    <MenuItem value="Yes">Yes</MenuItem>
                    <MenuItem value="No">No</MenuItem>
                  </Select>
                </FormControl>

                {meetingDone === "Yes" && (
                  <>
                    <FormControl fullWidth style={{ marginBottom: 15 }} variant="outlined" size="small">
                      <InputLabel>Meeting Type *</InputLabel>
                      <Select
                        value={meetingType}
                        onChange={(e) => setMeetingType(e.target.value)}
                        label="Meeting Type *"
                        size="small"
                      >
                        <MenuItem value="Office Meet">Office Meet</MenuItem>
                        <MenuItem value="Residence Meeting">Residence Meeting</MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl fullWidth style={{ marginBottom: 15 }} variant="outlined" size="small">
                      <TextField
                        label="Meeting Done Date *"
                        name="meetingDate"
                        type="date"
                        value={meetingDate || ''}
                        onChange={(e) => setMeetingDate(e.target.value)}
                        InputLabelProps={{
                          shrink: true
                        }}
                        variant="outlined"
                        size="small"
                      />
                    </FormControl>
                  </>
                )}
              </>
            )}

            {/* Reason for Lost */}
            <FormControl fullWidth style={{ marginBottom: 15 }} variant="outlined" size="small">
              <InputLabel htmlFor="unified-reason-lost">Reason for Lost *</InputLabel>
              <Select
                labelId="unified-reason-lost-label"
                id="unified-reason-lost"
                value={salesLostReason}
                label="Reason for Lost *"
                onChange={handleSelectSalesLostReason}
                size="small"
              >
                {salesLostReasonOptions.map((row, i) => (
                  <MenuItem key={i + 1} value={row.name}>
                    {row.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            {/* Remarks */}
            <FormControl fullWidth variant="outlined" size="small">
              <TextField
                label="Remarks"
                name="unifiedLostRemarks"
                value={unifiedLostRemarks}
                onChange={(e) => setUnifiedLostRemarks(e.target.value)}
                variant="outlined"
                size="small"
                multiline
                rows={3}
              />
            </FormControl>
          </div>
        </DialogContent>
        <DialogActions>
          <div style={{ margin: "10px", display: 'flex', gap: 10 }}>
            <Button
              onClick={handleUnifiedLostSubmit}
              color="primary"
              variant="contained"
              disabled={
                (refundEligible && wantsRefund === null) ||
                salesLostReason === '' ||
                (wantsRefund === 'yes' && refundEligible && (!unifiedRefundAmount || parseFloat(unifiedRefundAmount) <= 0)) ||
                (unifiedDepartment === 'Sales' && meetingDone === '') ||
                (unifiedDepartment === 'Sales' && meetingDone === "Yes" && (!meetingType || !meetingDate))
              }
            >
              Submit
            </Button>
            <Button
              onClick={handleUnifiedLostCancel}
              color="secondary"
              variant="contained"
            >
              Cancel
            </Button>
          </div>
        </DialogActions>
      </Dialog>
    </div>
  );
};
export default connect(null, { setUserDetails, setLoading, setSnackInfo })(
  RaiseRefundRequest
);